export const displayFloor = (floor: number): string => {
    if (floor === -1) {
        return 'Lower Ground Floor';
    }
    if (floor === 0) {
        return 'Ground Floor';
    }
    return `Floor ${floor}`;
};
